import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationMessage } from '../messages/ApplicationMessage';

const error = 'alert-danger';
const warn = 'alert-warning';
const success = 'alert-success';
const info = 'alert-info';
const maxMessagesToDisplay = 5;

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  public messages: ApplicationMessage[];

  constructor(private toast: ToastrService) {
    this.messages = [];
  }

  error(message: string) {
    this.addMessage(message, error);
    if(message || message.trim().length > 0) {
      this.toast.error(message);
    } 
  }

  info(message: string) {
    this.addMessage(message, info);
    this.toast.info(message);
  }

  warning(message: string) {
    this.addMessage(message, warn);
    this.toast.warning(message);
  }

  success(message: string) {
    this.addMessage(message, success);
    this.toast.success(message);
  }

  clearMessage(id: number): void {
    this.messages.splice(id, 1);
  }

  clearAll(): void {
    this.messages = [];
  }

  private addMessage(message: string, type: string): void {
    console.log(type + ' : ' + JSON.stringify(message));
    let m = new ApplicationMessage(message, type);
    const index = this.messages.findIndex(
      msg => msg.text === message && msg.type === type
    );
    if (index !== -1) {
      m = this.messages[index];
      m.count++;
      this.clearMessage(index); // Clear then add again so the message appears as new with an updated count
    }

    if (this.messages.push(m) > maxMessagesToDisplay) {
      this.messages.splice(0, 1); // Remove the oldest message if we have too many
    }
  }
}
